import deepmerge from 'deepmerge';

import { useEffect, useState } from 'react';
import { Config, defaultConfig, HeaderConfig } from '../headerConfig';

function useSourceArray(destinationArray, sourceArray) {
  return sourceArray;
}

export default function useConfig(userDefinedConfig: HeaderConfig) {
  const [config, setConfig] = useState<Config>(
    deepmerge(userDefinedConfig, defaultConfig, {
      arrayMerge: useSourceArray
    })
  );

  useEffect(() => {
    setConfig(
      deepmerge(defaultConfig, userDefinedConfig, {
        arrayMerge: useSourceArray
      })
    );
  }, [userDefinedConfig]);

  return config;
}
